define(function(require, exports, module) {
    'use strict';

    const CashierMethodView = require('portlets/cashier/cashier.method.view');

    module.exports = CashierMethodView.extend({

        additionalEvents: {
            'tap .fn-change-account': 'addAnotherAccount'
        },

        addAnotherAccount: function(e) {
            var $fnAccountId = this.$('.fn-account-id:not(.fn-is-hidden-field)');
            var $fnIsHiddenField = this.$('.fn-is-hidden-field');
            var accountCode = e.target.value;

            CashierMethodView.prototype.addAnotherAccount.apply(this, arguments);

            if (e.target.getAttribute('value') === 'add') {
                $fnAccountId.removeClass('hidden');
                $fnAccountId.find('input').removeAttr('disabled');

                $fnIsHiddenField.removeClass('hidden');
                $fnIsHiddenField.find('input').removeAttr('disabled', '');
            } else {
                $fnAccountId.addClass('hidden').attr('disabled', '');
                $fnAccountId.find('input').attr('disabled', '');

                $fnIsHiddenField.addClass('hidden');
                $fnIsHiddenField.find('input').attr('disabled', '');
                this.setAccountFields(accountCode);
            }
        },

        isHiddenField: function(field /*, method */) {
            return field.isLabelField && !field.isAccountKey && !field.isRequired || (field.label === 'IBAN' && this.model.get('account')?.length);
        }
    });
});
